export const getSeason = (articleNumber: string) => {
  // articlenumber => 1170174018240
  const seasonCode = articleNumber.slice(-3); // it will be 240 for above article number

  // get season code
  const seasonNumber = Number.parseInt(seasonCode.slice(-1)); // it will give 0 for 240, 8 for 248
  let seasonString = '';
  if (seasonNumber === 0) {
    seasonString = '10';
  } else if (seasonNumber > 0 && seasonNumber < 10) {
    seasonString = `0${seasonNumber}`;
  }

  // get year from article number
  const year = Number.parseInt(seasonCode.slice(0, 2)); // it will give 24 for both 240 and 248
  const yearString = `20${year}`;

  const season = yearString + seasonString; // it will give 202410 for 240 and 202408 for 248
  return season;
};

export const formatSeason = (articleNumber: string) => {
  const season = getSeason(articleNumber);
  if (season.length === 6) {
    return season.slice(0, 4) + '/' + season.slice(4);
  }
  return season;
};
